const Hero = ({ data }) => (
  <Fragment>
    <h1 className="sr-only">Pomegranate Opera</h1>
    <section className="pt4 md:pt5 pb7 xl:pb8 tc">
      <BgImage image={data.image.childImageSharp.sizes} />
      <LogoAndTagline data={data} />
    </section>
  </Fragment>
)

export default Hero

/*
 *
 * Imports
 *
 */

import React, { Fragment } from 'react'

import Img from '../components/base/Img'

/*
 *
 * Background Image
 *
 */

const BgImage = ({ image }) => (
  <Img
    sizes={image}
    alt=""
    critical={true}
    className="fill"
    style={{ position: `absolute`, zIndex: `-1` }}
    objPosition="65% 0%"
  />
)

/*
 *
 * Intro
 *
 */

const LogoAndTagline = ({ data }) => (
  <div className="container pb6 sm:pb7 xl:pt5">
    <Img
      sizes={data.logo.childImageSharp.sizes}
      alt={data.logoAlt}
      critical={true}
      className="ml-auto mr-auto w-90 sm:w-80 md:mw6 xl:measure"
    />

    <p className="mt3 f3 white">{data.description}</p>
  </div>
)



// WEBPACK FOOTER //
// ./src/sections/Hero.js